import { render, staticRenderFns } from "./mshop.vue?vue&type=template&id=407008c0&scoped=true"
import script from "./mshop.vue?vue&type=script&lang=js"
export * from "./mshop.vue?vue&type=script&lang=js"
import style0 from "./mshop.vue?vue&type=style&index=0&id=407008c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407008c0",
  null
  
)

export default component.exports